import { noop } from 'lodash';
import { memo } from 'react';

import { EllipsisVerticalIcon } from '@air/design-icons';
import { DropdownMenu, type DropdownMenuOption, renderDropdownItems } from '@air/primitive-dropdown-menu';
import { IconButton } from '@air/primitive-icon-button';

import { ASSET_MODAL_HEADER_ELLIPSIS } from '~/constants/testIDs';

export const OptionsMenu = memo(({ options }: { options: DropdownMenuOption[] }) => {
  return (
    <DropdownMenu
      size="large"
      trigger={
        <IconButton
          adsIcon
          appearance="ghost"
          color="gray"
          data-testid={ASSET_MODAL_HEADER_ELLIPSIS}
          icon={EllipsisVerticalIcon}
          label="See options"
          onClick={noop}
          size="medium"
        />
      }
    >
      {renderDropdownItems({ options })}
    </DropdownMenu>
  );
});

OptionsMenu.displayName = 'OptionsMenu';
